// eslint-disable-next-line
/// <reference path="../pug.d.ts" />
// @ts-check
'use strict';

const { removeOutsideQuotes } = require('../utils/string');

/** @type {string[]} */
const ALLOWED_TAGS = [
  'div',
  'li',
  'ol',
  'p',
  'ul',
  'dl',
  'dt',
  'dd',
  'a',
  'br',
  'span',
  'strong',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'tr',
  'img',
  'video',
  'noscript',
  'picture',
  'source',
  'h2',
  'h3',
  // NOTE: style タグのスコープを限定する仕組みがないので、ここで定義したスタイルが他の要素に影響を与えるリスクがある。しかし、リスクとしてはカスタム CSS と同じなので許容する
  // TODO: style のスコープを限定できるようにする
  'style',
];

/** @type {Record<string, string[]>} */
const ALLOWED_ATTRIBUTES = {
  a: ['href', 'target'],
  img: ['src', 'alt', 'width', 'height', 'loading'],
  style: ['type'],
  source: ['src', 'type', 'srcset'],
  video: ['src', 'autoplay', 'loop', 'muted', 'playsinline', 'controls', 'poster'],
  th: ['colspan', 'rowspan'],
  td: ['colspan', 'rowspan'],
  '*': ['class', 'style', 'data-.+'], // NOTE: * を全ての html タグとする
};

const isUrl = (url) => {
  return url.startsWith('http://') || url.startsWith('https://') || url.startsWith('/');
};

/** @param {string} url */
const isAllowedHref = (url) => {
  return isUrl(url) || url.startsWith('#');
};

/**
 * @param {string} attributeName
 * @param {string} attributeValue
 */
const isAllowedAttributeValue = (attributeName, attributeValue) => {
  if (attributeName === 'href') {
    return isAllowedHref(attributeValue);
  }

  if (attributeName === 'src') {
    return isUrl(attributeValue);
  }

  return true;
};

/**
 * @param {string} tagName
 * @param {string} attributeName
 */
const isAllowedAttribute = (tagName, attributeName) => {
  if (ALLOWED_ATTRIBUTES['*'] && ALLOWED_ATTRIBUTES['*'].some((attr) => new RegExp(attr).test(attributeName))) {
    return true;
  }

  if (ALLOWED_ATTRIBUTES[tagName] && ALLOWED_ATTRIBUTES[tagName].some((attr) => new RegExp(attr).test(attributeName))) {
    return true;
  }

  return false;
};

/**
 * @param {PugAst.PugNode.AnyNode} node
 * @returns {PugAst.PugNode.AnyNode}
 */
const deleteDisallowTagAndAttribute = (node) => {
  if (node.type !== 'Tag') {
    return node;
  }

  // NOTE: ホワイトリストにないタグは削除
  if (!ALLOWED_TAGS.includes(node.name)) {
    return {
      type: 'Text',
      val: '',
      line: node.line,
    };
  }

  const sanitizedAttrs = node.attrs.filter((attr) => {
    const attributeValueWithoutBracket = removeOutsideQuotes(attr.val);
    return isAllowedAttribute(node.name, attr.name) && isAllowedAttributeValue(attr.name, attributeValueWithoutBracket);
  });

  return {
    ...node,
    attrs: sanitizedAttrs,
  };
};

module.exports = { deleteDisallowTagAndAttribute };
